<autocomplete-list-item (clicked)="triggerEvent()"> {{ item._id }} </autocomplete-list-item>
